import { useState } from "react";
import { useHttp } from "../../common/http/httpService";

const useDocumentSubmissionService = () => {

  const http = useHttp();
  const [confirmationNumber, setConfirmationNumber] = useState(null);
  const [submissionComplete, setSubmissionComplete] = useState(false);

  const setUploadUrls = async(categoryOptionId, documents) => {
    const model = {
      categoryOptionId,
      documents: documents.map(function(document) {
        return {
          files: document.files.map(function(file) {
            return { fileName: file.name };
          })
        };
      })
    };
  
    const result = await http.post('/documentuploadurl', model);

    for (let docIndex = 0; docIndex < documents.length; docIndex++) {
      const docToUpload = documents[docIndex];
      const resultDoc = result.documents[docIndex];

      for (let fileIndex = 0; fileIndex < docToUpload.files.length; fileIndex++) {
        docToUpload.files[fileIndex].blobUrl = resultDoc.files[fileIndex].blobUrl;
      }
    }

    return result.documentSubmissionId;
  };
  
  const postFiles = (documents) => {

    const promises = [];
  
    for (let docIndex = 0; docIndex < documents.length; docIndex++) {
      const document = documents[docIndex];
  
      for (let fileIndex = 0; fileIndex < document.files.length; fileIndex++) {
        const file = document.files[fileIndex];
  
        promises.push(http.request({
          method: 'PUT',
          url: file.blobUrl,
          data: file,
          headers: {
            'Content-Type': file.type,
            'x-ms-blob-type': 'BlockBlob'
          }
        }));
      }
    }
  
    return Promise.all(promises);
  };
  
  const createDocuments = (documentSubmissionId) => {
    return http.post('/documentsubmission/' + documentSubmissionId);
  };

  const submitDocuments = async(categoryOptionId, documents) => {
    setSubmissionComplete(false);
    try {
      const documentSubmissionId = await setUploadUrls(categoryOptionId, documents);
      await postFiles(documents);
      const confirmation = await createDocuments(documentSubmissionId);
      setConfirmationNumber(confirmation);
    }
    finally {
      setSubmissionComplete(true);
    }
  }
  
  return { submitDocuments, confirmationNumber, submissionComplete };
};

export { useDocumentSubmissionService };